var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemoval = function SvgRemoval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#222}")), /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16z",
    style: {
      fill: "#a6ddda"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.42 17.25a.628.628 0 0 0-.88 0l-1.42 1.42-1.44-1.44a.628.628 0 0 0-.88 0c-.24.24-.24.64 0 .88l1.44 1.44-1.44 1.44c-.24.24-.24.64 0 .88.12.12.28.18.44.18s.32-.06.44-.18l1.44-1.44 1.42 1.42c.12.12.28.18.44.18s.32-.06.44-.18c.24-.24.24-.64 0-.88L20 19.55l1.42-1.42a.61.61 0 0 0 0-.88z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.03 13.62c.06-.27.1-.56.1-.85a4.66 4.66 0 0 0-4.65-4.65c-1.89 0-3.57 1.15-4.27 2.85-.17-.03-.35-.04-.53-.04-1.51 0-2.78 1.01-3.16 2.44-.05 0-.09-.01-.15-.01-2.05 0-3.71 1.67-3.71 3.71 0 2.05 1.67 3.71 3.71 3.71h4.15c.34 0 .62-.28.62-.62s-.28-.62-.62-.62h-4.15c-1.36 0-2.47-1.11-2.47-2.47s1.11-2.47 2.47-2.47c.75 0 1.11.25 1.42.51.26.22.65.19.88-.07a.63.63 0 0 0-.07-.88c-.23-.2-.5-.4-.85-.55.26-.85 1.02-1.45 1.93-1.45.26 0 .51.04.71.12.17.07.35.06.51-.02.16-.08.28-.23.32-.4a3.353 3.353 0 0 1 3.26-2.51c1.88 0 3.41 1.53 3.41 3.41 0 .2-.03.4-.07.6-.51-.01-1.07.08-1.51.25-.32.12-.48.48-.36.8.12.32.49.48.8.36.46-.18 1.08-.21 1.41-.14 1.13.25 1.89 1.21 1.94 2.43 0 .74-.33 1.44-.9 1.91-.27.22-.31.61-.09.88a.616.616 0 0 0 .87.09c.86-.71 1.36-1.76 1.36-2.9-.06-1.56-.96-2.87-2.31-3.42z",
    className: "st1"
  })));
};
export default SvgRemoval;